import { cn } from '@/lib/utils';

export const AdPlacement = ({ 
  type = 'banner', // 'banner', 'rectangle', 'inline', 'sidebar'
  className,
  ...props 
}) => {
  const sizes = {
    banner: { width: '728px', height: '90px', label: 'Banner Ad (728x90)' },
    rectangle: { width: '300px', height: '250px', label: 'Rectangle Ad (300x250)' },
    inline: { width: '100%', height: '100px', label: 'In-Content Ad' },
    sidebar: { width: '300px', height: '600px', label: 'Sidebar Ad (300x600)' },
    leaderboard: { width: '100%', height: '90px', label: 'Leaderboard Ad (970x90)' },
  };

  const config = sizes[type] || sizes.banner;

  return (
    <div
      className={cn(
        'ad-placeholder p-4 text-center',
        type === 'rectangle' || type === 'sidebar' ? 'adsense-container-lg' : 'adsense-container',
        className
      )}
      style={{ 
        maxWidth: config.width,
        minHeight: config.height,
      }}
      {...props}
    >
      <div className="flex flex-col items-center justify-center h-full gap-2">
        <span className="text-xs font-medium text-muted-foreground/70">
          {config.label}
        </span>
        <span className="text-xs text-muted-foreground/50">
          Advertisement
        </span>
      </div>
    </div>
  );
};

export default AdPlacement;
